module.exports = __webpack_public_path__ + "static/wright1-ff3b3f0c01f932b3e10ba8f81d74dc87.jpg";